// Paginacion.js - Controles de paginación: « Anterior · 1 … 4 5 6 … 20 · Siguiente »
import React from 'react';

/** Números a mostrar: siempre la primera, la última y dos vecinas de la actual (con "…" entre medio). */
const paginasVisibles = (actual, total) => {
  const set = new Set([1, total, actual - 2, actual - 1, actual, actual + 1, actual + 2]);
  const nums = [...set].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
  const out = [];
  nums.forEach((n, i) => {
    if (i > 0 && n - nums[i - 1] > 1) out.push(`gap-${n}`);
    out.push(n);
  });
  return out;
};

const Paginacion = ({ pagina, totalPaginas, total, porPagina, onCambiar, deshabilitado = false, etiqueta = 'resultados' }) => {
  if (!totalPaginas || totalPaginas <= 1) {
    return total ? <p className="ach-pag-info" style={{ textAlign: 'center' }}>{total} {etiqueta}</p> : null;
  }
  const desde = (pagina - 1) * porPagina + 1;
  const hasta = Math.min(pagina * porPagina, total);

  return (
    <nav className="ach-pag" aria-label="Paginación">
      <p className="ach-pag-info">
        Mostrando {desde}–{hasta} de {total} {etiqueta}
      </p>
      <div className="ach-pag-btns">
        <button
          type="button"
          className="ach-pag-btn"
          onClick={() => onCambiar(pagina - 1)}
          disabled={deshabilitado || pagina <= 1}
          aria-label="Página anterior"
        >
          ‹ <span className="ach-pag-txt">Anterior</span>
        </button>
        {paginasVisibles(pagina, totalPaginas).map((n) =>
          typeof n === 'string' ? (
            <span key={n} className="ach-pag-gap" aria-hidden="true">…</span>
          ) : (
            <button
              key={n}
              type="button"
              className={`ach-pag-btn ach-pag-num${n === pagina ? ' is-active' : ''}`}
              onClick={() => onCambiar(n)}
              disabled={deshabilitado || n === pagina}
              aria-current={n === pagina ? 'page' : undefined}
              aria-label={`Página ${n}`}
            >
              {n}
            </button>
          )
        )}
        <button
          type="button"
          className="ach-pag-btn"
          onClick={() => onCambiar(pagina + 1)}
          disabled={deshabilitado || pagina >= totalPaginas}
          aria-label="Página siguiente"
        >
          <span className="ach-pag-txt">Siguiente</span> ›
        </button>
      </div>
    </nav>
  );
};

export default Paginacion;
